











































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import cPopup from '@/components/default/Popup.vue';
import kpiValuesRepository from '@/services/varia/kpiValuesRepository';
import kpiObjects from '../kpiObjects.json';

import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

import DxChart, {
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxLegend,
  DxSeries,
  DxTooltip,
  DxValueAxis,
  DxConstantLine,
} from 'devextreme-vue/chart';

@Component({
    components: {
        cCard,
        cPopup,
        DxForm,
        DxSimpleItem,
        DxGroupItem,
        DxLabel,
        DxChart,
        DxArgumentAxis,
        DxLegend,
        DxSeries,
        DxCommonSeriesSettings,
        DxTooltip,
        DxValueAxis,
        DxConstantLine,
    },
})
export default class DashboardGraph extends Vue {
    @Prop({required: true})
    public value!: IDashboardGraph;

    private data: IGraphDto = {
        daily: [],
        weekly: [],
        monthly: [],
    };
    private dataset: IGraphValueDto[] = [];
    private loading: boolean = false;

    private item: IDashboardGraph = {
        itemType: 'graph',
        name: '',
        width: 12,
        type: '',
        category: '',
        preset: 0,
        begin: '',
        end: '',
        interval: 0,
        showCumulative: true,
    };

    private showSettings: boolean = false;

    private async mounted() {
        Object.assign(this.item, this.value);
        this.loadData();
    }

    private customizeTooltip(pointInfo: any) {
      return {
        html: `<div><div class='tooltip-header'>${
          pointInfo.argumentText
        }</div><div class='tooltip-body'><div class='series-name'>${
          pointInfo.points[0].seriesName
        }: </div><div class='value-text'>${
          pointInfo.points[0].valueText
        }</div><div class='series-name'>${
          pointInfo.points[1].seriesName
        }: </div><div class='value-text'>${
          pointInfo.points[1].valueText
        }</div></div></div>`,
      };
    }

    private async loadData() {
        this.loading = true;
        if (this.dataValid) {
            this.data = (await kpiValuesRepository.GetLookup({
                begin: this.item.begin,
                end: this.item.end,
                category: this.item.category,
                type: this.item.type,
            })).data;

            let totalDaily = 0;
            this.data.daily.forEach((element) => {
                totalDaily += element.value;
                element.value = Math.round(element.value * 100) / 100;
                (element as any).cumulative = Math.round(totalDaily * 100) / 100;
            });

            let totalWeekly = 0;
            this.data.weekly.forEach((element) => {
                totalWeekly += element.value;
                element.value = Math.round(element.value * 100) / 100;
                (element as any).cumulative = Math.round(totalWeekly * 100) / 100;
            });

            let totalMonthly = 0;
            this.data.monthly.forEach((element) => {
                totalMonthly += element.value;
                element.value = Math.round(element.value * 100) / 100;
                (element as any).cumulative = Math.round(totalMonthly * 100) / 100;
            });

            switch (this.item.interval) {
                case 0:
                    this.dataset = this.data.daily;
                    break;
                case 1:
                    this.dataset = this.data.weekly;
                    break;
                case 2:
                    this.dataset = this.data.monthly;
                    break;
            }
        }
        this.loading = false;
    }

    private changeSettings() {
        this.showSettings = true;
    }

    private saveSettings() {
        this.$emit('input', this.item);
        this.showSettings = false;
    }

    private stringHasValue(value: string) {
        if (!value || value === '') {
            return false;
        }
        return true;
    }

    get dataValid() {
        if (this.stringHasValue(this.item.begin) &&
        this.stringHasValue(this.item.end) &&
        this.stringHasValue(this.item.category) &&
        this.stringHasValue(this.item.type)) {
            return true;
        }
        return false;
    }

    get presetOptions() {
        return {
            items: [
                {value: 0, text: 'Custom'},
            ],
            valueExpr: 'value',
            displayExpr: 'text',
        };
        /*
        {value: 1, text: 'Dit jaar'},
                {value: 2, text: 'Laatste 12 maanden'},
                {value: 3, text: 'Laatste 3 maanden'},
                {value: 4, text: 'Laatste 30 dagen'},
                {value: 5, text: 'Laatste 7 dagen'},
        */
    }

    get categoryOptions() {
        return {
            items: kpiObjects.categories,
            valueExpr: 'value',
            displayExpr: 'display',
        };
    }

    get typeOptions() {
        return {
            items: kpiObjects.types.filter((o) => o.category === this.item.category),
            valueExpr: 'value',
            displayExpr: 'display',
        };
    }

    get intervalOptions() {
        return {
            items: [
                {value: 0, text: 'Dagelijks'},
                {value: 1, text: 'Weekelijks'},
                {value: 2, text: 'Maandelijks'},
            ],
            valueExpr: 'value',
            displayExpr: 'text',
        };
    }

    get widthOptions() {
        return {
            items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        };
    }

    get title() {
        if (this.item.name && this.item.name !== '') {
            return this.item.name;
        }

        return 'Grafiek';
    }
}
